// extracted by mini-css-extract-plugin
export var benefitSection = "styles-module--benefitSection--d1310";
export var benefitSectionDark = "styles-module--benefitSectionDark--3bc7e";
export var benefitSectionLight = "styles-module--benefitSectionLight--362d8";
export var btnSection = "styles-module--btnSection--04390";
export var columns = "styles-module--columns--cac25";
export var iconImage = "styles-module--iconImage--f1581";